import React from "react";

function Header() {
    return(
        <header>
            <h1 className="text-2xl font-bold underline"> Hello world! </h1>
        </header>
    )
}

export default Header;